angular
  .module('datepicker.components', [])
  .component('datepicker', {
    templateUrl: 'ng/components/datepicker/datepicker.html',
    bindings: {
      language: '@',
      inputPlaceholder: '@',
      inputId: '@',
      inputName: '@',
      inputClass: '@',
      bindingVariable: '=',
      startDate: '<',
      endDate: '<',
      stringDate: '@',
      disabledDays: '<',
      disabledDates: '<',
      disableHolidays: '<',
      onChange: '<',
      inputTabindex: '@',
      reinitializeOnClick: '<',
    },
    controllerAs: 'datepickerCtrl',
    controller: function ($scope, $timeout) {

      //Not to loose the *this reference
      var self = this;
      self.lang = "it";
      //self.bindingVariable = {};
      //self.startDate = '';
      //self.endDate = '';
      //self.disabledDays = '';
      //self.disabledDates = '';
      //self.onChange = function(){};

      self.$onInit = function () {
        self.lang = self.language;
        if (self.startDate === 'today') {
          self.startDate = moment().format("DD/MM/YYYY");
        }
        if (self.endDate === 'today') {
          self.endDate = moment().format("DD/MM/YYYY");
        }
        self.startDate = self.startDate || '';
        self.endDate = self.endDate || '';
        self.stringDate = self.stringDate || '';
        self.disabledDays = self.disabledDays || '';
        self.disabledDates = self.disabledDates || [];
        self.disableHolidays = self.disableHolidays || false;
        self.onChange = self.onChange || function () {};
        if (self.disableHolidays) {

        }
        self.reinitializeOnClick = self.reinitializeOnClick || false;
        self.initDatepicker();

      }

      self.$onChanges = function (e) {
        self.language == '' ? self.lang = 'it' : self.lang = self.language;
        //self.updateDatepicker();
        if((e.startDate && e.startDate.currentValue || e.endDate && e.endDate.currentValue) && self.reinitializeOnClick){
          self.initDatepicker();
        }

      }

      self.isDateEnabled = function (date) {
        var disabledDates = self.disabledDates || [];
        var day = (date.getDate() < 10) ? ("0" + date.getDate()) : date.getDate();
        var month = date.getMonth() + 1;
        month = (month < 10) ? ("0" + month) : month;
        var date = day + '-' + month;
        if (disabledDates.indexOf(date) != -1)
          return false;
        else
          return true;
      }

      self.initDatepicker = function () {
        $('.input-group.date#' + self.inputId).datepicker('destroy');
        if (self.disableHolidays) {
          var disabledDates = self.disabledDates || [];
          var lang = self.lang;
          var startDate = self.startDate;
          var endDate = self.endDate;
          var disabledDates = self.disabledDates;
          var disabledDays = self.disabledDays;
          var isDateEnabled = self.isDateEnabled;
          var options = {
            weekStart: 1,
            language: lang,
            autoclose: true,
            todayHighlight: true,
            startDate: startDate,
            endDate: endDate,
            datesDisabled: disabledDates,
            daysOfWeekDisabled: disabledDays,
            assumeNearbyYear: moment().format("YY"),
            immediateUpdates: true,
            templates: {
              leftArrow: '<i class="fa fa-caret-left"></i>',
              rightArrow: '<i class="fa fa-caret-right"></i>'
            },
            format: 'dd/mm/yyyy',
            beforeShowDay: function (date) {
              return isDateEnabled(date);
            }
          };

          $timeout(function () {
            $('.input-group.date#' + self.inputId).datepicker(options);
          }, 0)
        } else {
          $timeout(function () {
            $('.input-group.date#' + self.inputId).datepicker({
              weekStart: 1,
              language: self.lang,
              autoclose: true,
              todayHighlight: true,
              startDate: self.startDate,
              endDate: self.endDate,
              datesDisabled: self.disabledDates,
              daysOfWeekDisabled: self.disabledDays,
              assumeNearbyYear: moment().format("YY"),
              immediateUpdates: true,
              templates: {
                leftArrow: '<i class="fa fa-caret-left"></i>',
                rightArrow: '<i class="fa fa-caret-right"></i>'
              },
              format: 'dd/mm/yyyy'
            }); 
          }, 0);
        }
      }
    }
  });